(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.collection-image-wrapper').forEach(function(wrapper) {
    const mobileSize = wrapper.getAttribute('data-mobile-size');
    if (window.innerWidth <= 749 && mobileSize === '2x1') {
      wrapper.classList.add('collection-image--mobile-2x1');
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  class NewsletterPopup {
    constructor(element) {
      this.element = element;
      this.popupId = element.dataset.popupId;
      this.delay = element.dataset.delay;
      this.storageKey = `popup-closed-${this.popupId}`;
      this.closeButton = element.querySelector('.newsletter-popup__close');
      this.overlay = element.querySelector('.newsletter-popup__overlay');
      this.form = element.querySelector('.newsletter-popup__form');

      this.init();
    }

    init() {
      if (sessionStorage.getItem(this.storageKey)) {
        return;
      }

      this.closeButton.addEventListener('click', () => this.close());
      this.overlay.addEventListener('click', () => this.close());

      if (this.form) {
        this.form.addEventListener('submit', () => {
          sessionStorage.setItem(this.storageKey, 'true');
        });
      }

      this.show();
    }

    show() {
      const delays = {
        immediate: 0,
        '10s': 10000,
        scroll: null,
        idle: 60000
      };

      const delayTime = delays[this.delay];

      if (this.delay === 'scroll') {
        this.setupScrollTrigger();
      } else {
        setTimeout(() => {
          this.element.style.display = 'block';
          requestAnimationFrame(() => {
            this.element.classList.add('is-visible');
          });
        }, delayTime);
      }
    }

    setupScrollTrigger() {
      const checkScroll = () => {
        const scrollPercent =
          (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;

        if (scrollPercent > 80) {
          this.element.style.display = 'block';
          requestAnimationFrame(() => {
            this.element.classList.add('is-visible');
          });
          window.removeEventListener('scroll', checkScroll);
        }
      };

      window.addEventListener('scroll', checkScroll);
    }

    close() {
      this.element.classList.remove('is-visible');
      sessionStorage.setItem(this.storageKey, 'true');

      setTimeout(() => {
        this.element.style.display = 'none';
      }, 300);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const popups = document.querySelectorAll('.newsletter-popup');
    popups.forEach((popup) => new NewsletterPopup(popup));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-collections"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const tabs = document.querySelectorAll('.tab-link');
    const panels = document.querySelectorAll('.tab-panel');

    tabs.forEach(tab => {
      tab.addEventListener('click', function() {
        const targetTab = this.getAttribute('data-tab');

        tabs.forEach(t => t.classList.remove('active'));
        panels.forEach(p => p.classList.remove('active'));

        this.classList.add('active');
        panels[targetTab].classList.add('active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.testimonials__video-wrapper').forEach(function(wrapper) {
    var video = wrapper.querySelector('video');
    if (!video) return;
    wrapper.addEventListener('click', function() {
      if (wrapper.classList.contains('is-playing')) {
        video.pause();
        wrapper.classList.remove('is-playing');
      } else {
        document.querySelectorAll('.testimonials__video-wrapper.is-playing').forEach(function(other) {
          other.querySelector('video').pause();
          other.classList.remove('is-playing');
        });
        video.play();
        wrapper.classList.add('is-playing');
      }
    });
    video.addEventListener('ended', function() { wrapper.classList.remove('is-playing'); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-promotion-popup"] && !Shopify.designMode) return;
  try {
    
    class TextPromotionPopup {
      constructor(element) {
        this.element = element;
        this.popupId = element.dataset.popupId;
        this.delay = element.dataset.delay;
        this.storageKey = `popup-closed-${this.popupId}`;
        this.closeButton = element.querySelector('.text-promotion-popup__close');
        
        this.init();
      }

      init() {
        if (sessionStorage.getItem(this.storageKey)) {
          return;
        }

        this.closeButton.addEventListener('click', () => this.close());

        this.show();
      }

      show() {
        const delays = {
          'immediate': 0,
          '10s': 10000,
          'scroll': null,
          'idle': 60000
        };

        const delayTime = delays[this.delay];

        if (this.delay === 'scroll') {
          this.setupScrollTrigger();
        } else {
          setTimeout(() => {
            this.element.style.display = 'block';
            requestAnimationFrame(() => {
              this.element.classList.add('is-visible');
            });
          }, delayTime);
        }
      }

      setupScrollTrigger() {
        const checkScroll = () => {
          const scrollPercent = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
          
          if (scrollPercent > 80) {
            this.element.style.display = 'block';
            requestAnimationFrame(() => {
              this.element.classList.add('is-visible');
            });
            window.removeEventListener('scroll', checkScroll);
          }
        };

        window.addEventListener('scroll', checkScroll);
      }

      close() {
        this.element.classList.remove('is-visible');
        sessionStorage.setItem(this.storageKey, 'true');
        
        setTimeout(() => {
          this.element.style.display = 'none';
        }, 300);
      }
    }

    document.addEventListener('DOMContentLoaded', () => {
      const popups = document.querySelectorAll('.text-promotion-popup');
      popups.forEach(popup => new TextPromotionPopup(popup));
    });
  
  } catch(e) { console.error(e); }
})();
})();
